import { render } from "./CallUpdateForm.vue?vue&type=template&id=eb5d40c0"
import script from "./CallUpdateForm.vue?vue&type=script&lang=js"
export * from "./CallUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__